import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Header } from "../components/site/Header";
import { Footer } from "../components/site/Footer";

const INTRO =
  "Conformément aux dispositions de la loi n° 2004-575 du 21 juin 2004 pour la Confiance dans l'Économie Numérique (LCEN), il est porté à la connaissance des utilisateurs et visiteurs du site bestconduite78.fr les présentes mentions légales.";

const SECTIONS = [
  {
    title: "1. Éditeur du site",
    paragraphs: [
      "Raison sociale : BEST CONDUITE — Société par Actions Simplifiée (SAS) au capital social de 100 €.",
      "Siège social : 137 Rue du Général Leclerc, 78400 Chatou.",
      "SIREN : 940 642 846 — SIRET (siège social) : 940 642 846 00015.",
      "N° TVA Intracommunautaire : FR88 940 642 846.",
      "Code NAF/APE : 85.53Z – Enseignement de la conduite.",
      "Date de création : 16 janvier 2025.",
      "Téléphone : +33 6 66 69 80 49 — Email : contact@bestconduite78.fr.",
    ],
  },
  {
    title: "2. Directeur de la publication",
    paragraphs: [
      "Le directeur de la publication est Madame Linda AID, en sa qualité de Présidente de la société BEST CONDUITE.",
    ],
  },
  {
    title: "3. Hébergement du site",
    paragraphs: [
      "Hébergeur : IONOS SE — 7 Place de la Gare, 57200 Sarreguemines, France.",
      "Téléphone : 0970 808 911 — Site web : www.ionos.fr.",
    ],
  },
  {
    title: "4. Activité réglementée",
    paragraphs: [
      "BEST CONDUITE est un établissement d'enseignement de la conduite et de la sécurité routière.",
      "Agrément préfectoral : N° 11788823578, délivré par la Préfecture des Yvelines (78).",
    ],
  },
  {
    title: "5. Propriété intellectuelle",
    paragraphs: [
      "L'ensemble des contenus présents sur le site bestconduite78.fr (textes, images, logos, graphismes, vidéos, etc.) est la propriété exclusive de la société BEST CONDUITE ou de ses partenaires, et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle.",
      "Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans l'autorisation écrite préalable de BEST CONDUITE.",
    ],
  },
  {
    title: "6. Protection des données personnelles (RGPD)",
    paragraphs: [
      "Conformément au Règlement Général sur la Protection des Données (RGPD) n° 2016/679 du 27 avril 2016 et à la loi Informatique et Libertés n° 78-17 du 6 janvier 1978 modifiée, vous disposez des droits suivants concernant vos données personnelles :",
    ],
    list: [
      "Droit d'accès à vos données",
      "Droit de rectification de vos données",
      "Droit à l'effacement (droit à l'oubli)",
      "Droit à la limitation du traitement",
      "Droit à la portabilité de vos données",
      "Droit d'opposition au traitement",
    ],
    after: [
      "Pour exercer ces droits, vous pouvez contacter BEST CONDUITE : par courrier : 137 Rue du Général Leclerc, 78400 Chatou ; par téléphone : +33 1 30 71 04 37 ; par email : contact@bestconduite78.fr.",
      "Pour toute réclamation, vous pouvez également contacter la CNIL : www.cnil.fr – 3 Place de Fontenoy, TSA 80715, 75334 Paris Cedex 07.",
    ],
  },
  {
    title: "7. Cookies",
    paragraphs: [
      "Le site bestconduite78.fr est susceptible d'utiliser des cookies afin d'améliorer l'expérience utilisateur. Conformément à la réglementation en vigueur, votre consentement est recueilli avant le dépôt de tout cookie non essentiel.",
      "Vous pouvez à tout moment paramétrer vos préférences en matière de cookies via les paramètres de votre navigateur ou via le gestionnaire de cookies présent sur notre site.",
    ],
  },
  {
    title: "8. Liens hypertextes",
    paragraphs: [
      "Le site bestconduite78.fr peut contenir des liens vers des sites tiers. BEST CONDUITE ne saurait être tenu responsable du contenu de ces sites externes et de l'usage qui pourrait être fait des informations qui y sont disponibles.",
    ],
  },
  {
    title: "9. Limitation de responsabilité",
    paragraphs: [
      "BEST CONDUITE s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur son site. Toutefois, BEST CONDUITE ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur le site et décline toute responsabilité pour toute imprécision, inexactitude ou omission.",
    ],
  },
  {
    title: "10. Droit applicable et juridiction compétent",
    paragraphs: [
      "Les présentes mentions légales sont soumises au droit français. En cas de litige, et à défaut de résolution amiable, les tribunaux français seront seuls compétents.",
    ],
  },
];

export default function MentionsLegales() {
  useEffect(() => {
    document.title = "Mentions légales — Bestconduite78, auto-école à Chatou (78)";
    return () => {
      document.title = "Bestconduite78 — Auto-école à Chatou (78) | Permis B, Code, Conduite accompagnée";
    };
  }, []);

  return (
    <>
      <Header />
      <main className="pt-[130px] pb-24" data-testid="mentions-legales-page">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 text-sm font-bold text-violet-700 hover:underline"
          >
            <ArrowLeft size={15} /> Retour à l'accueil
          </Link>
          <h1 className="font-heading font-extrabold tracking-tight text-slate-900 text-3xl sm:text-4xl mt-6">
            Mentions légales
          </h1>
          <p className="text-slate-600 text-sm sm:text-base leading-relaxed mt-6">{INTRO}</p>
          <div className="mt-10 space-y-10">
            {SECTIONS.map((s) => (
              <section key={s.title} data-testid={`legal-section-${s.title.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}>
                <h2 className="font-heading font-bold text-slate-900 text-lg sm:text-xl">{s.title}</h2>
                {s.paragraphs.map((p, i) => (
                  <p key={i} className="text-slate-600 text-sm sm:text-base leading-relaxed mt-3">{p}</p>
                ))}
                {s.list && (
                  <ul className="mt-3 space-y-1.5 list-disc list-inside text-slate-600 text-sm sm:text-base">
                    {s.list.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                )}
                {s.after &&
                  s.after.map((p, i) => (
                    <p key={i} className="text-slate-600 text-sm sm:text-base leading-relaxed mt-3">{p}</p>
                  ))}
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
